import API from "@core/api/api";

// Custom Pricing API functions
export const createCustomPricing = async (pricingData) => {
  const response = await API.post("/settings/custom-pricing", pricingData);
  return response.data;
};

export const updateCustomPricing = async (id, pricingData) => {
  const response = await API.put(`/settings/custom-pricing/${id}`, pricingData);
  return response.data;
};

export const deleteCustomPricing = async (id) => {
  const response = await API.delete(`/settings/custom-pricing/${id}`);
  return response.data;
};

export const getAllCustomPricings = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await API.get(`/settings/custom-pricing?${queryString}`);
  return response.data;
};

export const getCustomPricingById = async (id) => {
  const response = await API.get(`/settings/custom-pricing/${id}`);
  return response.data;
};

export const getMyCustomPricings = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await API.get(`/settings/my-custom-pricing?${queryString}`);
  return response.data;
};

export const bulkCreateCustomPricing = async (pricingsData) => {
  const response = await API.post(
    "/settings/custom-pricing/bulk",
    pricingsData
  );
  return response.data;
};
